<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="item in changelabel">{{ item }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Breadcrumb',
  data() {
    return {

    }
  },
  methods:{
    processMenuItem(item) {
      if (this.users.leader === 1) {
        if (item === '待接案列表') {
          item = '待审批接案列表'
        } else if (item === '诉前在办') {
          item = '案管审批'
        }
      }
      return item
    },
  },
  computed: {
    ...mapState('m_user', ['users']),


 
    changelabel() {
      let res = []
      this.$route.matched.forEach(item => {

        res.push(this.processMenuItem(item.meta.label))

      });
      return res
    }
  },
}
</script>

<style></style>
